import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
  name: 'nmiExp'
})
export class NmiExpPipe implements PipeTransform {
  transform(value: number | string): string {
    if (!value) return '';
    
    const expStr = value.toString().padStart(4, '0');
    
    const month = expStr.slice(0, -2);
    const year = expStr.slice(-2);
    
    return `${month}/${year}`;
  }
}
